import type { PropsWithChildren, ReactNode } from "react";

import { cn } from "@bentolabs/kit/utils";

type Props = {
  className?: string;
  label: string;
  tvl: string;
  title: string;
  description: string;
  img: ReactNode;
  button: ReactNode;
};

export const Card = ({
  className,
  label,
  tvl,
  title,
  description,
  children,
  img,
  button,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        className,
        "bg-baltic-sea/30 relative flex flex-col overflow-hidden rounded-3xl pt-3 backdrop-blur-xl"
      )}
    >
      <div className="absolute -top-1/5 -left-1/3 h-[300px] w-[600px] rounded-full bg-radial from-current/10 to-transparent to-60%"></div>
      <header className="wrap flex justify-between gap-1 px-3">
        <div className="flex items-center justify-center rounded-xl bg-current/15 px-3 py-2 leading-none whitespace-nowrap">
          {label}
        </div>
        <div className="bg-onyx/70 flex items-center justify-center gap-x-2.5 rounded-xl px-3 py-2">
          <span className="inline-flex text-current/70">TVL:</span> {tvl}
        </div>
      </header>

      <main className="mt-12.5 mb-6 flex flex-col items-center justify-center">
        <div className="size-16 rounded-[18px] bg-current p-2.5">{img}</div>
        <h3 className="mt-6 text-2xl leading-[105%] text-white">{title}</h3>
        <p className="text-nobel/70 mt-2 text-center leading-[150%] whitespace-pre-line">
          {description}
        </p>

        {children}
      </main>

      <footer className="mt-auto flex w-full overflow-hidden rounded-br-xl rounded-bl-3xl">
        {button}
      </footer>
    </div>
  );
};
